import React, { useContext } from 'react'
import { matchPath, Outlet, useLocation } from 'react-router-dom'
import Header from './components/Header/header'
import Footer from './components/Footer/footer'

import GoToTop from './components/goToTop'
import { Container, Stack } from '@airbus/components-react/components'
import LightDarkContext from 'context/LightDarkModeContext'

const Layout = () => {
  const { pathname } = useLocation()
  const isPageEmpty = matchPath(process.env.PUBLIC_URL || '', pathname)
  const { getBackgroundColor } = useContext(LightDarkContext)

  return (
    <Stack
      style={{ backgroundColor: getBackgroundColor(Boolean(isPageEmpty)), minHeight: '100vh' }}
      wrapChildren={false}
    >
      <Header />
      <Outlet />
      <Footer />
      {!isPageEmpty && <GoToTop idComponentForScroll='' />}
    </Stack>
  )
}

export default Layout
